/*
 * InSight Analytics Solutions Limited
 * https://fieldpro.onyxinsight.com/
 *
 * Copyright (c) 2021 Onyx InSight Field Pro.
 * This file is licensed to InSight Analytics Solutions Limited
 */
import React, { useState } from 'react';
import CookieConsent from 'react-cookie-consent';
import { Button } from 'devextreme-react/button';
import { CheckBox } from 'devextreme-react/check-box';
import './cookiesManagement.scss';

export const CookiesBar = () => {
  const [openCookies, setOpenCookies] = useState(false);
  return (
    <CookieConsent
      location="bottom"
      disableStyles={true}
      buttonText={<span className={`dx-icon-close`}></span>}
      declineButtonText=""
      declineButtonStyle=""
      containerClasses={openCookies ? 'showCokies' : 'cookiesContainer'}
      //  buttonWrapperClasses="closeIcon"
      cookieName="language"
      buttonStyle={{
        color: 'white',
        fontSize: '13px',
        right: '18px',
        position: 'absolute',
        top: '22px',
      }}>
      <p className="headerText">🍪 Cookies & Privacy</p>
      <p className="cookiesText">
        Cookies enable you to personalize your experience on our sites, tell us
        which parts of our websites people have visited, and give us insight
        into user behavior so we can improve our products. You may choose to
        prevent this website from aggregating and analyzing the actions you take
        here. Doing so will protect your privacy, but will also prevent us from
        learning from your actions and creating a better experience for you and
        other users.
        <span className="linkStyle">
          <a
            href="https://onyxinsight.com/privacy/"
            target="_blank"
            rel="noopener noreferrer">
            {' '}
            More information
          </a>
        </span>
      </p>
      {openCookies ? (
        <div>
          <span className="innerHeader">Select cookies to accept</span>
          <div className="checkBoxesContainer">
            <CheckBox
              text="Neccessary"
              disabled={true}
              value={true}
              className="neccessaryCheckBox"
            />
            <CheckBox text="Analytics" className="analyticsCheckbox" />
          </div>
        </div>
      ) : (
        ''
      )}
      <Button
        className="customiseButtonCss"
        text="Customise Cookies"
        width="180"
        disabled={openCookies ? true : false}
        onClick={() => {
          setOpenCookies(true);
        }}
      />
    </CookieConsent>
  );
};
